import ahoy from "ahoy.js"

// Matches Ahoy.cookies = false on the server (config/initializers/ahoy.rb).
// Every pack bundles its own copy of ahoy.js, so import ahoy from here.
ahoy.configure({ cookies: false })

export default ahoy
